"use client";

import { memo } from "react";
import type { BlockConfig } from "@/lib/registry/types";
import { getDynamicDemoComponent } from "@/app/(app)/components/_utils/load-demo";
import { ComponentErrorBoundary } from "@/components/primitives/component-error-boundary";

interface DynamicDemoRendererProps {
  component: BlockConfig & {
    previewProps?: {
      previewPath: string;
      hasPreviewImage: boolean;
      availablePreviewFiles: string[];
      demoFiles: string[];
    };
  };
}

export const DynamicDemoRenderer = memo(
  ({ component }: DynamicDemoRendererProps) => {
    if (!component.previewProps?.demoFiles?.length) return null;

    const demoFile = component.previewProps.demoFiles[0];
    const DemoComponent = getDynamicDemoComponent(component, demoFile);

    if (!DemoComponent) return null;

    return (
      <ComponentErrorBoundary
        componentName={component.name}
        className="max-h-full max-w-full"
        showError={true}
      >
        <div className="max-h-full max-w-full transform scale-90 transition-transform duration-300 group-hover:scale-95">
          <DemoComponent />
        </div>
      </ComponentErrorBoundary>
    );
  }
);

DynamicDemoRenderer.displayName = "DynamicDemoRenderer";
